module.exports = __webpack_public_path__ + "assets/de3d77f3466679fa63bb3ea8f64c0213.png";